const state = {
    item: {
        default: {
            comission: '',
            deployment_commision: '',
            min_quotes: '',
            max_quotes: '',
            commissioned_vehicles: [],
            inadvertencies: [],
            groups: []
        },
        bonus: {
            initial_date: '',
            final_date: '',
            by_quotas: []
        },
        billing: {
            ranges: []
        },
        campaign: {
            initial_date: '',
            final_date: '',
            min_quantity: '',
            Commission: '',
            quotas: [],
            amounts: [],
            closing_months: []
        },
        installments: [],
        inadvertencies: [],
        surplus: {
            min_value: 0,
            commision_on_first_installment: 0,
            commision_on_second_installment: 0
        },
        type_sales: []
    }
};
export default state;